import React from 'react';

interface SettingsRowProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** Right-side slot — toggle, value, button, badge, etc. */
  control?: React.ReactNode;
  /** When set, the row is rendered as a button-like clickable card. */
  onClick?: () => void;
  className?: string;
  /** Extra content rendered below the head (icon/title/control row), e.g.
   *  an inline input that appears when a toggle is on. */
  children?: React.ReactNode;
  /** Visual de-emphasis for unavailable / disabled rows. */
  disabled?: boolean;
}

export const SettingsRow: React.FC<SettingsRowProps> = ({
  icon,
  title,
  description,
  control,
  onClick,
  className = '',
  children,
  disabled,
}) => {
  const interactive = !!onClick && !disabled;
  const classes = [
    'kx-settings-row',
    interactive ? 'kx-settings-row--clickable' : '',
    disabled ? 'kx-settings-row--disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const head = (
    <div className="kx-settings-row__head">
      {icon && <span className="kx-settings-row__icon">{icon}</span>}
      <div className="kx-settings-row__text">
        <div className="kx-settings-row__title">{title}</div>
        {description && <div className="kx-settings-row__desc">{description}</div>}
      </div>
      {control && <div className="kx-settings-row__control">{control}</div>}
    </div>
  );

  if (interactive) {
    return (
      <button type="button" className={classes} onClick={onClick} disabled={disabled}>
        {head}
        {children && <div className="kx-settings-row__body">{children}</div>}
      </button>
    );
  }

  return (
    <div className={classes}>
      {head}
      {children && <div className="kx-settings-row__body">{children}</div>}
    </div>
  );
};

export default SettingsRow;
